import { render } from "./IndexPage.vue?vue&type=template&id=c7c0a826&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"

import "./IndexPage.vue?vue&type=style&index=0&id=c7c0a826&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7c0a826"]])

export default __exports__